import { render } from "./PageFormLatarBelakangPendidikan.vue?vue&type=template&id=dfa5a6f0"
import script from "./PageFormLatarBelakangPendidikan.vue?vue&type=script&lang=js"
export * from "./PageFormLatarBelakangPendidikan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__